import { generate } from '@ant-design/colors'

/**
 * Màu gốc — chỗ DUY NHẤT khai hex trong toàn hệ.
 * Rebrand = đổi giá trị ở đây, 10 sắc độ tự sinh lại.
 * Chỉ số sắc độ theo AntD: index 5 là màu chính (tương ứng "blue-6" trong tài liệu AntD).
 */
export const hues = {
  brand: '#1a5fe8',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#1677ff',
} as const

export type HueName = keyof typeof hues

const DARK_BACKGROUND = '#141414'

const buildPalette = (opts?: { theme: 'dark'; backgroundColor: string }) =>
  Object.fromEntries(
    Object.entries(hues).map(([name, hex]) => [name, generate(hex, opts)])
  ) as Record<HueName, string[]>

export const palette = buildPalette()
export const paletteDark = buildPalette({ theme: 'dark', backgroundColor: DARK_BACKGROUND })

/**
 * Thang cách. Đơn vị gốc 8px theo spec AntD.
 * `xxs` (4) và `sm` (12) là NỬA BƯỚC — chỉ dùng bên trong component dày đặc
 * (tag, ô nhập nhỏ). Khoảng cách ở tầng bố cục trang chỉ dùng bội số của 8.
 */
export const space = { xxs: 4, xs: 8, sm: 12, md: 16, lg: 24, xl: 32, xxl: 48 } as const

export const radius = { sm: 4, md: 8, lg: 12, full: 9999 } as const

/** Cỡ gốc 14 / line-height 22 theo AntD. Giữ đúng 5 cỡ — AntD khuyến nghị 3–5. */
export const fontSize = { sm: 12, base: 14, lg: 16, xl: 20, xxl: 24 } as const
export const lineHeight = { sm: 20, base: 22, lg: 24, xl: 28, xxl: 32 } as const

/** Chỉ ba mức. `semibold` chỉ dùng cho tiêu đề. */
export const fontWeight = { regular: 400, medium: 500, semibold: 600 } as const

export const shadow = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.08)',
  md: '0 2px 8px rgba(0, 0, 0, 0.12)',
  lg: '0 6px 16px rgba(0, 0, 0, 0.16)',
} as const

export const zIndex = { base: 0, sticky: 10, dropdown: 1050, modal: 1000, toast: 1100 } as const
